<template>
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
  >
    <path d="M6.1939 0.601789C6.52403 -0.0671307 7.47789 -0.0671346 7.80802 0.601788L9.32911 3.68384L12.7304 4.17807C13.4685 4.28534 13.7633 5.19251 13.2291 5.7132L10.768 8.11224L11.349 11.4997C11.4751 12.235 10.7034 12.7956 10.0431 12.4485L7.00096 10.8491L3.95879 12.4485C3.29853 12.7956 2.52684 12.235 2.65294 11.4997L3.23394 8.11224L0.772773 5.7132C0.238609 5.19251 0.533365 4.28534 1.27156 4.17807L4.67281 3.68384L6.1939 0.601789Z" fill="#FFC259"/>
  </svg>
</template>
